import React from "react";

const Footer = () => (
  <div id="footer" className="row">
    <div className="container panels section mb-5">
      <div className="row">
        <div className="col order-sm-2">
          <div className="row">
            <div className="col-12 col-md text-center text-md-left">
              <ul>
                <li>Company</li>
                <li>
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/careers">Careers</a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md text-center text-md-left">
              <ul>
                <li>Product</li>
                <li>
                  <a href="/pricing">Pricing</a>
                </li>
                <li>
                  <a href="/docs">API Docs</a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md text-center text-md-left">
              <ul>
                <li>Conditions</li>
                <li>
                  <a href="/terms">Terms of Use</a>
                </li>
                <li>
                  <a href="/disclaimer">Disclaimer</a>
                </li>
                <li>
                  <a href="/code_of_ethics">Code of Ethics</a>
                </li>
                <li>
                  <a href="/privacy">Privacy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-sm-6 mt-5 mt-md-0 text-center text-md-left order-sm-1">
          <h2>Spawner AI</h2>
          <p>
            Build AI into any application.
            <br /> info@spawner.ai
            <div>
              <a href="https://www.twitter.com">
                <img src="/images/twitter_icon.png" alt="" />
              </a>
              <a href="https://www.discord.com">
                <img src="/images/discord_icon.png" alt="" />
              </a>
              <a href="https://www.github.com">
                <img src="/images/github_icon.png" alt="" />
              </a>
            </div>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
